import { Col } from 'antd';
import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as S from './styles';
import { SimcardsDashboard } from './SimcardsDashboard';
import SimcardsStateDashboard from './SimcardsStateDashboard';

export const SimcardsOnlineProducts: React.FC = () => {
  const stateProduct = 'by-state';

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const statusFilterParam = searchParams.get('statusFilter');

  const [currentDevice, setCurrentDevice] = useState(
    statusFilterParam || 'by-product',
  );

  const handleViewChange = useCallback((view: string) => {
    setCurrentDevice(view);
  }, []);

  return (
    <S.ContainerRow gutter={[16, 16]}>
      <Col span={24}>
        {stateProduct === currentDevice ? (
          <SimcardsStateDashboard onViewChange={handleViewChange} />
        ) : (
          <SimcardsDashboard
            currentDevice={currentDevice}
            onViewChange={handleViewChange}
          />
        )}
      </Col>
    </S.ContainerRow>
  );
};
